import { render, staticRenderFns } from "./LookedUpTypeColumn.vue?vue&type=template&id=c6d79ef2&"
import script from "./LookedUpTypeColumn.vue?vue&type=script&lang=ts&"
export * from "./LookedUpTypeColumn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports